import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StatusVersionEnum } from './shared/services/enums/status-version.enum';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  constructor(private router: Router) {}

  /**
   * Redireciona a página de acordo com o status da versão.
   * Se já estiver na rota correta, não faz nada.
   */
  redirectByStatus(idStatusVersion: number, idBookVersion: number, isCreditReviewing: boolean, isPaymentApproved: boolean = false): void {
    const statusRouteMap: { [key: number]: string } = {
      [StatusVersionEnum.Upload]:        '/livro-upload',
      [StatusVersionEnum.Capa]:          '/livro-capa',
      [StatusVersionEnum.Material]:      '/livro-impressao',
      [StatusVersionEnum.AguardandoPagamento]: isCreditReviewing || isPaymentApproved ? '/livro-detalhes' : '/livro-pagamento',
      [StatusVersionEnum.DadosDoLivro]:  '/livro-detalhes',
      [StatusVersionEnum.RevisaoDaEditora]: '/livro-status',
      [StatusVersionEnum.AguardandoAjustesDoAutor]: '/livro-aprovacao',
      [StatusVersionEnum.AguardandoAprovacaoDoAutor]: '/livro-aprovacao',
      [StatusVersionEnum.Publicado]:     '/editar-publicacao',
      [StatusVersionEnum.PublicacaoSuspensa]:     '/editar-publicacao',

    };

    const targetRoute = statusRouteMap[idStatusVersion];
    if (!targetRoute) {
      console.warn(`Nenhuma rota configurada para idStatusVersion: ${idStatusVersion}`);
      return;
    }

    const fullTarget = `${targetRoute}/${idBookVersion}`;
    const currentUrl = this.router.url;

    if (!currentUrl.includes(targetRoute)) {
      this.router.navigate([fullTarget]);
    }
  }
}
